import { css } from "styled-components";

const sizes = {
  phone: 767,
  smallPhone: 374,
  large: 768,
  tablet: 870,
  desktop: 991,
  wide: 1199,
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});

export function hexToRgba(hex, opacity = 1) {
  hex = hex.replace("#", "");
  hex = hex.length === 3 ? `${hex}${hex}` : hex;
  let red = parseInt(hex.substring(0, 2), 16);
  let green = parseInt(hex.substring(2, 4), 16);
  let blue = parseInt(hex.substring(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}

export function em(size) {
  const emSize = parseFloat(size.replace("px", "")) / 16;

  return `${emSize}em`;
}

export function rem(size) {
  const remSize = parseFloat(size.replace("px", "")) / 16;

  return `${remSize}rem`;
}
